import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import { ReactReduxContext } from 'react-redux';
import { resolveObj } from './dgObject.mjs';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function withReducer(WrappedComponent, reducerName, reducerObj) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);

    var _super = _createSuper(HOC);

    function HOC(props) {
      _classCallCheck(this, HOC);

      return _super.call(this, props);
    }

    _createClass(HOC, [{
      key: "render",
      value: function render() {
        var _this$context, _this$context$store;

        var state = (_this$context = this.context) === null || _this$context === void 0 ? void 0 : (_this$context$store = _this$context.store) === null || _this$context$store === void 0 ? void 0 : _this$context$store.getState();
        var stateVar = resolveObj(reducerName, state);

        if (stateVar == undefined) {
          var _this$context2, _this$context2$store, _this$context2$store$, _this$context3, _this$context3$store;

          (_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : (_this$context2$store = _this$context2.store) === null || _this$context2$store === void 0 ? void 0 : (_this$context2$store$ = _this$context2$store.reducerManager) === null || _this$context2$store$ === void 0 ? void 0 : _this$context2$store$.add(reducerName, // Resolve the name the reducer should have
          reducerObj // Extract the reducer object from the parent module
          );
          (_this$context3 = this.context) === null || _this$context3 === void 0 ? void 0 : (_this$context3$store = _this$context3.store) === null || _this$context3$store === void 0 ? void 0 : _this$context3$store.replaceReducer(this.context.store.reducerManager.reduce); // Replace the reducer with the updated reducer just created
        }

        return /*#__PURE__*/React.createElement(WrappedComponent, this.props);
      }
    }]);

    return HOC;
  }(React.Component);

  _defineProperty(HOC, "contextType", ReactReduxContext);

  return HOC;
}

export { withReducer as default };
